import { createTRPCProxyClient, httpBatchLink } from '@trpc/client';
import type { AppRouter } from '../../../portal-api/src/trpc/router';

const getApiUrl = (): string => {
  const apiUrl = import.meta.env.VITE_API_URL;
  if (apiUrl) return apiUrl;
  return '';
};

let tokenGetter: (() => Promise<string | null>) | null = null;

export const setTokenGetter = (getter: () => Promise<string | null>): void => {
  tokenGetter = getter;
};

export const trpc = createTRPCProxyClient<AppRouter>({
  links: [
    httpBatchLink({
      url: `${getApiUrl()}/trpc`,
      async headers(): Promise<Record<string, string>> {
        if (tokenGetter) {
          const token = await tokenGetter();
          if (token) {
            return { Authorization: `Bearer ${token}` };
          }
        }
        return {};
      },
    }),
  ],
});

export type { AppRouter };
